import React from 'react';
import './overviewloader.css';

const OverviewLoader = props => {
    const { message = '' , height = '500px' } = props;

    return(
        <div className={'ovrvLoader'} style={{height : height}}>
            <div className={'ovrvLoader__content'}>
                <div className={'ovrvLoader__content__loader'}></div>
                <div className={'font16 greyText textCenter appendTop5'}>
                    {message}
                </div>
            </div>
        </div>
    );
}

export default OverviewLoader;